import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { toast } from "@hubertai/hubert-component-library";
import { fetchViewerProfile } from "../../behavior/api/viewer";
import { clearTokenFromStorage } from "../../behavior/security/auth.service";
import { useMyHubertSession } from "../../pages/instantJobApply/useMyHubertSession";

import "./TransitionPage.css";

type TransitionState = {
    redirectUrl: string;
    logout: boolean;
    emailVerified: boolean;
};

type TransitionPageProps = {
    title?: string;
    subtitle?: string;
};

const TransitionPage = (props: TransitionPageProps) => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { logoutUser } = useMyHubertSession();
    const [transitionPageData, setTransitionPageData] = useState<TransitionPageProps>(() => ({
        title: props.title ?? t("TransitionPage.loading-title"),
        subtitle: props.subtitle ?? t("TransitionPage.loading-subtitle"),
    }));

    useEffect(() => {
        const getCurrentViewer = async () => {
            try {
                if (location.state) {
                    const { redirectUrl, logout } = location.state as TransitionState;
                    if (logout) {
                        setTransitionPageData({
                            title: t("TransitionPage.logout-title"),
                            subtitle: t("TransitionPage.logout-subtitle"),
                        });
                        await logoutUser();
                        clearTokenFromStorage();
                    } else {
                        await fetchViewerProfile();
                    }

                    const currentUrl = location.pathname + location.search;
                    if (currentUrl !== redirectUrl) {
                        navigate(redirectUrl, { replace: true, state: location.state });
                    }
                }
            } catch (e) {
                const errorMessage = e instanceof Error ? e.message : "Something went wrong!";
                toast.error(errorMessage);
            }
        };

        getCurrentViewer();
    }, [location, t, logoutUser, navigate]);

    return (
        <section className="loader-container">
            <div className="logo">
                <div className="hubert-left">
                    <div className="inner" />
                </div>
                <div className="hubert-right" />
            </div>
            <div>
                <p className="text-sm md:text-base">My Hubert</p>
                <h3 className="text-lg font-medium md:text-3xl">{transitionPageData.subtitle}</h3>
            </div>
        </section>
    );
};

export default TransitionPage;
